import {dispatch} from '../utils/generalUtils';
import {SHOW_ALERT, HIDE_ALERT, SAVE_USER_IMAGE_BASE46, SAVE_USER_SIGN_BASE46, SAVE_ORG_IMAGE_BASE64} from '../constants/actions';

export function showAlert(params: Object, alertType: string, autoClose?: number) {
    return dispatch({
        type: SHOW_ALERT,
        params,
        alertType,
        autoClose
    });
}

export function hideAlert() {
    return dispatch({
        type: HIDE_ALERT
    });
}

export function saveUserImageBase64(imageBase64) {
    return dispatch({
        type: SAVE_USER_IMAGE_BASE46,
        imageBase64
    });
}

export function saveUserSignBase64(signBase64) {
    return dispatch({
        type: SAVE_USER_SIGN_BASE46,
        signBase64
    });
}

export function SaveOrgImageBase64(imageBase64) {
    return dispatch({
        type: SAVE_ORG_IMAGE_BASE64,
        imageBase64
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/miscellaneousActions.ts